/** Shared React Query key for `/auth/me`. Import this for invalidation. */
export const ACCOUNT_QUERY_KEY = ['account'] as const;

/**
 * Who may stay on a path once the session probe finishes.
 *
 * - `authed` — signed-in only; guests go to `/signin`.
 * - `guest`  — signed-out only; signed-in go to `/app` (no second login flow).
 * - `public` — either; CTAs adapt. `/auth/verify` is public for path purposes but
 *   short-circuits inside the page when a session already exists.
 *
 * Guards in `App.tsx` enforce this. Do not add an auth wall in a page without
 * updating here — the test locks the matrix.
 */
export type RouteAccess = 'public' | 'authed' | 'guest';

export function routeAccess(pathname: string): RouteAccess {
    if (pathname === '/app') return 'authed';
    if (pathname === '/' || pathname === '/signin') return 'guest';
    return 'public';
}
